import React, { useEffect, useState } from 'react'
import { React360Viewer } from 'react-360-product-viewer'
import Icon360 from '../assets/svg/circle360.inline.svg'
import PanoramaIMG from '../assets/imgs/CSHead/panorama.jpg'

import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer'

const CSHeadSpherePreview = ({
  exterior,
  interior,
  heading1,
  description1,
  heading2,
  description2,
  id = '',
}) => {
  useEffect(() => {
    changeThreesixyClass()
  })
  const [showTab, setShowTab] = useState(0)

  const changeThreesixyClass = () => {
    const TSDivs = document.querySelectorAll('.threesixty-view')

    TSDivs.forEach((div) => {
      const newItem = div.children.item(0)
      newItem.style.width = '100%'
      newItem.style.height = '100%'
      newItem.style.padding = '0'
      newItem.style.cursor = 'none'

      setTimeout(() => {
        const imgsCollection = [...newItem.getElementsByTagName('img')]
        imgsCollection.forEach((img) => {
          img.classList.add('threesixty-box__img')
          img.classList.add('threesixty-box__img--cover')
          img.setAttribute('alt', 'Blue KIA vehicle on turntable')
        })
      }, 600)
    })
  }
  return (
    <div
      id={id}
      className='lg:pt-[85px] container bg-black-100 text-white flex flex-col'
    >
      <div className='relative lg:-mr-[80px] lg:pl-0 lg:mx-0 lg:flex md:pt-0 md:-mx-[45px] pt-[45px] -mx-[24px]'>
        <div className='lg:absolute lg:bottom-0 lg:right-full lg:pr-[24.5px] lg:my-0 lg:px-0 lg:flex-col md:mt-[65px] md:mb-[45px] md:px-[45px] pl-[24px] flex items-center gap-[18px] mb-[30px]'>
          <p
            role='presentation'
            className={`${
              showTab === 0 ? 'text-white' : 'text-gray-300'
            } lg:order-3 lg:vertical-text uppercase text-[20px] cursor-pointer hover:text-orange transition-all duration-200 ease-in-out`}
            onClick={() => {
              setShowTab(0)
            }}
          >
            {exterior}
          </p>
          <i className='lg:order-2 lg:h-[45px] lg:w-[2px] w-[45px] h-[2px] bg-gray-300 opacity-50'></i>
          <p
            role='presentation'
            className={`${
              showTab === 1 ? 'text-white' : 'text-gray-300'
            } lg:order-1 lg:vertical-text uppercase text-[20px] cursor-pointer hover:text-orange transition-all duration-200 ease-in-out`}
            onClick={() => {
              setShowTab(1)
            }}
          >
            {interior}
          </p>
        </div>
        <div
          id='cs-custom-cursor'
          role='presentation'
          className='relative xl:h-[860px] lg:h-[710px] md:h-[450px] w-full h-[220px] cursor-pointer'
          onMouseMove={(e) => {
            const customCursor = document.getElementById('custom-cursor')

            if (customCursor.classList.contains('mix-blend-difference')) {
              customCursor.classList.remove('mix-blend-difference')
            }

            if (!customCursor.childNodes[0].classList.contains('hidden')) {
              customCursor.childNodes[0].classList.add('hidden')
            }

            if (customCursor.childNodes[1].classList.contains('hidden')) {
              customCursor.childNodes[1].classList.remove('hidden')
            }
          }}
          onMouseLeave={() => {
            const customCursor = document.getElementById('custom-cursor')

            if (!customCursor.classList.contains('mix-blend-difference')) {
              customCursor.classList.add('mix-blend-difference')
            }
            if (customCursor.childNodes[0].classList.contains('hidden')) {
              customCursor.childNodes[0].classList.remove('hidden')
            }

            if (!customCursor.childNodes[1].classList.contains('hidden')) {
              customCursor.childNodes[1].classList.add('hidden')
            }
          }}
        >
          <Icon360 className='icon360 absolute lg:bottom-[75px] md:bottom-[25px] bottom-[14px] left-1/2 -translate-x-1/2 z-[5]' />
          <div
            hidden={showTab !== 0}
            className='threesixty-view w-full h-full touch-none bg-white'
          >
            {/* FIRST TAB CONTENT */}
            <React360Viewer
              imagesBaseUrl='/Showcase/CSHeadExterior'
              imagesCount={8}
              imagesFiletype='jpg'
              mouseDragSpeed={0.2}
              imageFilenamePrefix='Exterior_'
            />
          </div>
          <div
            id='csheadviewer'
            hidden={showTab !== 1}
            className='w-full h-full touch-none bg-[#000] cursor-none'
          >
            {/* SECOND TAB CONTENT */}
            <ReactPhotoSphereViewer
            
              src={PanoramaIMG}
              height={'100%'}
              width={'100%'}
              keyboard={false}
              keyboardActions={false}
            ></ReactPhotoSphereViewer>
          </div>
        </div>
      </div>
      <div className='md:pb-[140px] md:pt-[70px] pt-[40px] pb-[48px]'>
        <div className='md:flex-row md:gap-[16px] shrink-0 flex flex-col'>
          <div className='md:basis-1/2'>
            <h2
              className='md:text-[32px] text-xl mb-[24px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {heading1}
            </h2>
            <p
              className='lg:max-w-[500px] md:mb-0 text-lg mb-[40px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {description1}
            </p>
          </div>
          <div className='md:basis-1/2'>
            <h2
              className='md:text-[32px] text-xl mb-[24px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {heading2}
            </h2>
            <p
              className='lg:max-w-[500px] md:mb-0 text-lg mb-[40px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {description2}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CSHeadSpherePreview
